
// Vue
import {Options, Vue} from "vue-class-component";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AdministratorNavigationVue from "@/components/administrator/navigation.vue";
import AdministratorResourcesNavigationVue from "@/components/administrator/resources/navigation.vue";
import AppAdministratorResourcesDietsListIndexVue from "@/views/app/administrator/resources/diets/list/index.vue";

@Options({
  components: {
    ElRow,
    ElCol,
    AdministratorNavigationVue,
    AdministratorResourcesNavigationVue,
    AppAdministratorResourcesDietsListIndexVue,
  },
})
export default class AppAdministratorResourcesDietsIndexVue extends Vue {}
